import React, {useState } from 'react';
import styled from 'styled-components'
import { SubmenuContainer } from './loadStopsInput';
import { AddButton, TaskListThreeDotsButton } from '../../content_management/reusableItems/buttons';
import { DragableList, DragHandle  } from '../../content_management/item_page/dragableList';
import cloneDeep from 'lodash/cloneDeep';
import { AddNewTaskMethod } from '../../content_management/task_list/taskListElements/addNewTask';
import { sendRequest, API_ROOT } from '../../../supplementary_components/requests';
import { NewOrEditTaskForm } from '../../content_management/task_list/taskListElements/newOrEditTaskForm';
import { ActionList } from '../../content_management/task_list/taskListElements/listOfActions';
import { addNotification } from '../../../supplementary_components/store';

const SectionTitle = styled.div`
    color:var(--light-gray);
    font-size:0.9rem;
    margin-left:0.7rem;
    span{
        font-size:0.9rem;
        float:right;
        margin-right:0.5rem;
    }
`;
export const TaskContainer = styled.div`
    display:grid;
    grid-template-columns: 1fr 1fr;
    padding: 0.8rem 0 0 0.5rem;
    position:relative;
`
const AddressSection = styled.div`
    
    .taskAddress{
        margin-top:0.6rem;
        margin-left:0.6rem;
        &.notSpecified{
            color:var(--lighter-gray);
        }
        &:not(.notSpecified){
            color:var(--dark-gray);
        }
        
        font-size:1.1rem;
        line-height:1.7rem;
        .cityState{
            font-weight:800;
        }
        .dateTimeSection{
            font-size:0.8rem;
        }
    }
`
export const AddNewTaskButtonFrame = styled.div`
    width:100%;
    margin-top:0.1rem;
    height:1rem;
    display:flex;
    border-radius:0.5rem;
    justify-content:center;
    align-items:center;
    transition: 0.3s;
    padding-top:0.2rem;
    &>div{
        display:none;
    }
    &:hover{
        background-color:var(--extra-light-gray);
        height:2rem;
        &>div{
            display:block;
            
        }
    }
    
`
const TaskWrapper = styled.div`
    width:100%;
    background-color:var(--bg);
    :nth-child(2){
        margin-right:-1rem;
        color:var(--dark-gray);
    }
`

export const TaskListField = ({defaultVal, changedTasks, newTask, taskWithDuration}) => {
    const [tasks, setTasks] = useState(defaultVal? cloneDeep(defaultVal.data): newTask[0]? cloneDeep(newTask) :[{actions:[]}]);    
    const setNewTaskAddress = (val) => {
        const tasksCopy = [...tasks];
        tasksCopy[0].address = {
            companyName: val[0].companyName === "" ? null: val[0].companyName,
            addressLine1: val[0].addressLine1 === "" ? null: val[0].addressLine1,
            addressLine2: val[0].addressLine2 === "" ? null: val[0].addressLine2,
            apptDate: val[0].apptDate === "" ? null: val[0].apptDate,
            apptTime: val[0].apptTime === "" ? null: val[0].apptTime,
            city: val[0].city === "" ? null: val[0].city,
            state: val[0].state === "" ? null: val[0].state,
            postalCode: val[0].postalCode === "" ? null: val[0].postalCode,
        }
        _setTasks(tasksCopy);
    }
    const _setTasks = (val) => { 
        newTask[0] = val[0];
        setTasks(val);
    }
    
    if(!defaultVal ){
        return  <NewOrEditTaskForm  tasks={tasks} _setTasks={_setTasks} setNewTaskAddress={setNewTaskAddress} taskWithDuration={taskWithDuration} />
    }
    const updateTasksEverywhere = (newTasks) => {
        // for(let task of newTasks){
        //     if(task.actions.length === 1 && task.actions[0].type === "reset"){                
        //         if(task.apptDate === null || task.apptDate === '' || task.apptTime === null || task.apptTime === ''){
        //             delete task.actions[0].resetEndETA;
        //         }else if(task.actions[0].durationInDays && task.apptDate !== null && task.apptDate !== '' && task.apptTime !== null && task.apptTime !== ''){
        //             task.actions[0].resetEndETA = dateTimeToResetEndString(task.apptDate, task.apptTime, task.actions[0].durationInDays);
        //         }
        //     }
        // }
        setTasks(newTasks);
        const newData = cloneDeep(defaultVal.objectData);
        newData.tasks=newTasks;  
                              
        defaultVal.setData(newData);
    }
    const addNewTaskAtIndex = (index) => {
        AddNewTaskMethod(tasks, (t)=>{
            updateTasksEverywhere(t);
        }, defaultVal.truckId, index, null);
    }
    const ListOfTasks = () => <>
        {tasks.map((value, index)=>{
            const address = value.address && !Object.values(value.address).every(value => value === null) ? value.address : null;
            
            return <TaskWrapper key={index}>
                <AddNewTaskButtonFrame >
                    <AddButton customSize={'1.2rem'} action={()=>{
                        addNewTaskAtIndex(index)
                    }} />
                </AddNewTaskButtonFrame>
                <span></span>
                <SubmenuContainer style={value.loadId === null?{display:'grid', gridTemplateColumns:"1fr 1.5rem"}:{paddingRight:'1.5rem'}}  $bottomPadding="0.5rem">
                    <TaskContainer className='removePadding' >
                        {Labels(value.loadId === null && (value.apptDate || value.apptTime)?`${value.apptDate ? value.apptDate.substr(0, 5) : null} ${value.apptTime ? value.apptTime : ''}`:null)}
                        <AddressSection>
                            {address ? <div className="taskAddress">
                                {address.companyName ? <>{address.companyName}<br /></>:null} 
                                {address.addressLine1 ? <>{address.addressLine1} <br /></> : null} 
                                {address.addressLine2 ? <> {address.addressLine2}  <br /> </>: null}
                                <span className="cityState">{`${address.city ? address.city +", " : ""}${address.state || ""}`}</span> {address.postalCode ? ` ${address.postalCode}` : null} 
                                {/* {value.loadId === null? <span className="dateTimeSection">({value.apptDate})</span>: null} */}
                            </div> : <div className="taskAddress notSpecified">Not Specified</div>}
                            
                        </AddressSection>
                        
                        
                        <ActionList currentTask={value} taskIndex={index} tasks={tasks} setTasks={setTasks} changedTasks={changedTasks} />
                        {value.loadId === null?
                            <TaskListThreeDotsButton position="absolute" top={'0.3rem'} left='89.8%' onRemove={()=>{
                                const body = cloneDeep(value);
                                
                                
                                sendRequest("PATCH", `${API_ROOT}trucks/removeTask/${defaultVal.truckId}`, null, (e)=>{
                                    const newTasks = [...tasks];
                                    for(let i = 0; i < newTasks.length; i++){
                                        if(newTasks[i].id === e.id){
                                            newTasks.splice(i, 1);
                                        }   
                                    }
                                    updateTasksEverywhere(newTasks);
                                }, ()=>{addNotification({message:`Something went wrong`, type:'alert'});}, body)
                                
                            }} onEdit={()=>{
                                AddNewTaskMethod(tasks, (t)=>{
                                    updateTasksEverywhere(t);
                                }, defaultVal.truckId, index, value);
                            }}  />
                            :null}
                    </TaskContainer>
                    {value.loadId === null?<DragHandle handleClassName='taskDragHandle' id="dragger" />:null}
                    
                </SubmenuContainer>
                
            </TaskWrapper>
        })}
        </>
        return <>
            <DragableList component={ListOfTasks} handleClassName='taskDragHandle' finishDrag={(inititIndex, currentIndex)=>{
                if (inititIndex !== currentIndex){
                    const tasksCopy = [...tasks];
                    const replacedTask = tasksCopy.splice(inititIndex, 1)[0];
                    tasksCopy.splice(currentIndex, 0, replacedTask);
                    setTasks(tasksCopy);
                    sendRequest("PATCH", `${API_ROOT}trucks/changeTaskOrder/${defaultVal.truckId}?fromIndex=${inititIndex}&toIndex=${currentIndex}`, null, ()=>{
                        const newData = cloneDeep(defaultVal.objectData);
                            newData.tasks=tasksCopy;                        
                            defaultVal.setData(newData);
                        }, ()=>{
                        //Return back
                        const tasksCopy = [...tasks];
                        const replacedTask = tasksCopy.splice(currentIndex, 1)[0];
                        tasksCopy.splice(inititIndex, 0, replacedTask);
                        setTasks(tasksCopy);
                    }, null)
                }
                return true
            }} />
            <AddNewTaskButtonFrame >
                <AddButton customSize={'1.2rem'} action={()=>{
                    addNewTaskAtIndex(tasks.length);
                }} />
            </AddNewTaskButtonFrame>
        </>
   
}
export const Labels = (dateAndTime) => {
    return <>
        <SectionTitle>
            Address{dateAndTime ? <span>{dateAndTime}</span> : null}
        </SectionTitle>
        <SectionTitle>
            Actions
        </SectionTitle>
    </>
}

